import { HotelRoomState } from "../hotel-rooms";
import { HscStoreState } from "../../hsc/defs";
import { HotelViewRoomDetailsState } from "../../view-room-details/defs";

export default function vuexSelectableDates(state: HotelRoomState | HscStoreState | HotelViewRoomDetailsState): string[] {
  console.group('vuexSelectableDates');
  const selectableDates: string[] = [];
  const selectedDate = state.checkInDate || state.checkOutDate;
  console.log('selectedDate', selectedDate);
  console.log('something not selected', (!state.checkInDate || !state.checkOutDate));
  //only set selectable dates if one date has been selected and one has not
  if (selectedDate && (!state.checkInDate || !state.checkOutDate)) {

    const latestPossibleDate = window.pepDateFunctions.addDays(selectedDate, state.maxDays);
    const earlyLastPossibleDate = window.pepDateFunctions.addDays(selectedDate, state.minDays * -1);
    const lateFirstPossibleDate = window.pepDateFunctions.addDays(selectedDate, state.minDays);
    let currentDate = window.pepDateFunctions.addDays(selectedDate, state.maxDays * -1);
    console.log('latestPossibleDate', latestPossibleDate);
    console.log('earlyLastPossibleDate', earlyLastPossibleDate);
    console.log('lateFirstPossibleDate', lateFirstPossibleDate);
    while (currentDate <= latestPossibleDate) {
      console.log('currentDate', currentDate);
      if (
        currentDate.getTime() <= earlyLastPossibleDate.getTime()
        || currentDate.getTime() >= lateFirstPossibleDate.getTime()
        || currentDate.getTime() === selectedDate.getTime()
      ) {
        selectableDates.push(window.pepDateFunctions.formatDateObjectYYYYMMDD(currentDate));
      }

      currentDate = window.pepDateFunctions.addDays(currentDate, 1);
    }
  }
console.groupEnd();
  return selectableDates;
}